import React, {Component, Fragment} from 'react';
import axios from 'axios'
import moment from 'moment';
import debounce from 'lodash/debounce';

import RequisitionSubmitModal from './RequisitionSubmitModal';
import Pagination from '../elements/Pagination';
import {phoneNumberMask, states, dateMask} from '../utilities';

class Item extends Component {
  constructor(props){
    super(props);
    this.state = {
      id: props.id,
      accessionID: props.accessionID,
      orderNumber: props.orderNumber,
      date: props.date,
      lastName: props.lastName,
      firstName: props.firstName,
      dob: moment.utc(props.dob).format("MM/DD/YYYY"),
      email: props.email,
      phone: props.phone,
      status: props.status,
      result: props.result ? props.result:"",
      isPCR: props.isPCR,
      sex: props.sex,
      address: props.address,
      city: props.city,
      state: props.state,
      zip: props.zip,
      showSubmitModal: false,
      labelCopies: 2,
      edit: false,
      test: props.test,
      openModal: false
    }
  }


  confirm = () => {
    let formData = {
      status: 'Sent'
    };
    axios({
      method: 'PUT',
      url: `${process.env.REACT_APP_URL}/covid/${this.state.id}`,
      data: formData,
    }).then(res => {
      this.setState({
        status: 'Sent',
      })
    }).catch(err => {
      console.log(err)
    });
  }

  render(){    
    let label;
    switch (this.state.status){
      case 'Sent':
        label = 'label-primary';
        break;
      case 'Pending':
        label = 'label-warning';
        break;
      default:
        break;
    }
    return(
      <Fragment>
        <tr>
          <td>{this.state.orderNumber}</td>
          <td>{moment(this.state.date).format("MM/DD/YYYY HH:mm")}</td>
          <td>{this.state.lastName}</td>
          <td>{this.state.firstName}</td>
          <td>{moment.utc(this.state.dob).format("MM/DD/YYYY")}</td>
          <td>{this.state.email}</td>
          <td>{this.state.phone}</td>
          <td style={{textAlign: 'center'}}><label className={`label ${label}`}>{this.state.status}</label></td>
          
          <td style={{textAlign: 'center'}}>
            {this.state.status === 'Sent' ? 
              <strong>SENT</strong>: <button className="btn btn-sm btn-primary" onClick={this.confirm}>SEND</button>
            }
          </td>
        </tr>
      </Fragment>
      
    )
  }
}

class List extends Component {
  constructor(props){
    super(props);
    this.state = {
      items: [],
      totalCount: '',
      hasMore: false,
      skip: 0,
      limit: 20,
      loading: true,

      searchByStatus: '',
      searchByLastName: '',
      searchByFirstName: '',
      searchByDate: '',
      searchByDOB: '',
      searchByAccession: '',
    }
  }

  componentDidMount(){
    // this.loadData()
  }

  componentDidUpdate(prevState){
    if(this.state.loading && !prevState.loading){
      this.loadData()
    }
  }

  loadData = () => {
    let params = {
      skip: this.state.skip,
      limit: this.state.limit,
      searchByClientID: this.props.user.clientID
    }
    if (this.state.searchByStatus){
      params.searchByStatus = this.state.searchByStatus
    }
    if (this.state.searchByLastName){
      params.searchByLastName = this.state.searchByLastName
    }
    if (this.state.searchByFirstName){
      params.searchByFirstName = this.state.searchByFirstName
    }
    if (this.state.searchByDate){
      params.searchByDate = this.state.searchByDate
    }
    if (this.state.searchByDOB){
      params.searchByDOB = this.state.searchByDOB
    }
    if (this.state.searchByAccession){
      params.searchByAccession = this.state.searchByAccession
    }   
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_URL}/covid`,
      params: params
    }).then(res => {
      this.setState({
        items: res.data.items,
        totalCount: res.data.totalCount,
        skip: res.data.skip,
        limit: res.data.limit,
        loading: false,
      })
    }).catch(err => {
      console.log(err)
      this.setState({
        items: [],
        loading: false,
      })
    });
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    console.log(value)
    this.setState({
      [name]: value,
      // loading: true
    })
  }

  onSkipChange = (skip) => {
    this.setState({
      skip: skip,
      loading: true
    })
  }

  clear = () => {
    this.setState({
      // loading: true,
      searchByStatus: '',
      searchByLastName: '',
      searchByFirstName: '',
      searchByDate: '',
      searchByDOB: '',
      searchByAccession: '',

      items: [],
      totalCount: '',
      hasMore: false,
      skip: 0,
      limit: 20,
    })
  }

  render(){
    return(
      <div className="row">
        <div className="col-xs-12">
          <div className="ibox req-ibox">
            <div className="ibox-title">
              <h5>PCR List</h5>
            </div>
            <div className="ibox-content">
              <strong className='text-danger'>NOTE: To avoid clerical errors and mislabel specimens, we removed the list of patients. You must physically search the patient to submit it to the Lab</strong> 
              <div className="row">
                <div className="col-xs-12">
                  <table className="table table-condensed table-hover table-bordered">
                    <thead>
                      <tr>
                        <th><button className="btn btn-sm btn-primary btn-block" onClick={this.loadData}><i className="fa fa-search"></i> Search</button></th>
                        <th><input className="form-control input-sm" type='date' name="searchByDate" value={this.state.searchByDate} onChange={this.handleChange}/></th>
                        <th><input className="form-control input-sm" placeholder="Search By Last Name" name="searchByLastName" value={this.state.searchByLastName} onChange={this.handleChange}/></th>
                        <th><input className="form-control input-sm" placeholder="Search By First Name" name="searchByFirstName" value={this.state.searchByFirstName} onChange={this.handleChange}/></th>
                        <th><input className="form-control input-sm" type='date' placeholder="Search By DOB" name="searchByDOB" value={this.state.searchByDOB} onChange={this.handleChange}/></th>
                        <th></th>
                        <th></th>
                        <th>
                          <select className="form-control input-sm" name="searchByStatus" value={this.state.searchByStatus} onChange={this.handleChange}>
                            <option value="">Search By Status</option>
                            <option value="pending">Pending</option>
                            <option value="final">Final</option>
                          </select>
                        </th>
                        <th style={{textAlign: 'center'}}><button className="btn btn-sm btn-default" onClick={this.clear}>Clear</button></th>
                      </tr>
                      <tr>
                        <th>Order Number</th>
                        <th>Order Date</th>
                        <th>Last Name</th>
                        <th>First Name</th>
                        <th>DOB</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.items.map(item => <Item key={item.id} {...item}/>)}
                    </tbody>
                    <tfoot>
                      <tr>
                        <td colSpan={9} style={{textAlign: "center"}}>
                          <Pagination
                            pages={Math.ceil(this.state.totalCount/this.state.limit)}
                            activePage={this.state.skip/this.state.limit}
                            onPageChange={(page) => { this.onSkipChange(this.state.limit*page)}}
                          />
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default List